import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './routes/App';
import "./i18n"
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import { Provider } from 'react-redux'
import { Toaster } from 'react-hot-toast';
import store from './store';
import NotFound from './routes/NotFound';
import Auth from './components/auth/Auth';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './utils/data';
import Home from './components/home/Home';
import ForgetPassword from './components/auth/ForgetPassword';
import TripLayout from './components/tripPage/TripLayout';
import Users from './components/dashboard/Users';
import Policy from './components/dashboard/Policy';
import ServicePage from './components/dashboard/Service';
import ArticlePage from './components/dashboard/Article';
import PlaceDetails from './components/dashboard/PlaceDetails';
import StayModal from './components/dashboard/models/StayModal';
import HallPage from './components/dashboard/Hall';
import SettingPage from './components/dashboard/Setting';
import Flight from './components/dashboard/Flight';
import Trip from './components/dashboard/Trip';
import TripModal from './components/dashboard/models/TripModal';
import TripDetails from './components/dashboard/TripDetails';
import ProtectedRoute from './routes/ProtectedRoute';
import SearchResult from './components/search/staySearch/SearchResult';
import HallSearchResult from './components/search/hallSearch/HallSearchResult';
import ArticleDetails from './components/artical/ArticleDetails';
import AboutSite from './components/about/About';
import Favorite from './components/favorite/Favorite';
import PlacePage from './components/placePage/PlacePage';
import StayPage from './components/dashboard/Stay';
import Offers from './components/offers/Offers';
import PlaceDetailsPage from './components/placePage/PlaceDetailsPage';
import RoomsAvailable from './components/placePage/RoomsAvailable';
import CheckOut from './components/placePage/CheckOut';
import LocationPage from './components/placePage/LocationPage';
import ProfileLayout from './components/profile/ProfileLayout';
import Profile from './components/profile/Profile';
import PaymentCards from './components/profile/PaymentCards';
import AnimatedCardForm from './components/profile/AnimatedCardForm';
import Wallet from './components/profile/Wallet';
import Security from './components/profile/Security';
import TermsOFUse from './components/profile/TermsOFUse';
import BookedHalls from './components/profile/BookedHalls';
import BookedStays from './components/profile/BookedStays';
import BookDetails from './components/profile/BookDetails';
import Books from './components/dashboard/Books';
import PlaceBooking from './components/dashboard/PlaceBooking';
import HallBooking from './components/dashboard/HallBooking';
import UserBooking from './components/dashboard/UserBooking';
import AdminBookDetails from './components/dashboard/AdminBookDetails';
import Rooms from './components/dashboard/Rooms';
import TripCheckOut from './components/trips/TripCheckOut';
import ProfileResetPassword from './components/profile/ProfileResetPassword';
import BookedTrips from './components/profile/BookedTrips';
import BookTripDetails from './components/profile/BookTripDetails';
import TripBooks from './components/dashboard/TripBooks';
import AdminTripBookDetails from './components/dashboard/AdminTripBookDetails';
import TripBooking from './components/dashboard/TripBooking';
import UserTripBooking from './components/dashboard/UserTripBooking';
import StaysLayout from './components/stays/StaysLayout';
import { HelmetProvider } from 'react-helmet-async';
import Success from './routes/Success';
import AddNumber from './components/profile/AddNumber';
import Terms from './components/home/Terms';
import DeletionInstruction from './components/home/DeletionInstruction';
import HallBookDetails from './components/profile/HallBookDetails';
import AdminHallBookDetails from './components/dashboard/AdminHallBookDetails';
const router = createBrowserRouter([
    {
        path: "/",
        caseSensitive: false,
        element: <App />,
        children: [
            { index: true, element: <Home /> },
            { path: "/about", element: <AboutSite /> },
            { path: "/stays", element: <StaysLayout /> },
            { path: "/favorite", element: <Favorite /> },
            { path: "/offers", element: <Offers /> },
            { path: "/trips/:tripId", element: <TripLayout /> },
            { path: "/trips/:tripId/check-out", element: <TripCheckOut/> },
            { path: "/articles/:articleId", element: <ArticleDetails /> },
            { path: "/stay-search-result", element: <SearchResult /> },
            { path: "/hall-search-result", element: <HallSearchResult /> },
            { path: "/delete-account", element: <DeletionInstruction/> },
            { path:"/terms", element: <Terms/> },
            {
                path: "/place/:placeId",
                element: <PlacePage />,
                children: [
                    { index: true, element: <PlaceDetailsPage/> },
                    { path: "/place/:placeId/rooms", element: <RoomsAvailable/> },
                    { path: "/place/:placeId/map-view", element: <LocationPage/> },
                    { path: "/place/:placeId/check-out", element: <CheckOut/> },
                ]
            },
            {
                path: "/me",
                element: <ProfileLayout />,
                children: [
                    { index: true, element: <Profile/> },
                    { path:"/me/payment-cards", element: <PaymentCards/> },
                    { path:"/me/payment-cards/add-card", element: <AnimatedCardForm/> },
                    { path:"/me/wallet", element: <Wallet/> },
                    { path:"/me/security", element: <Security/> },
                    { path:"/me/security/reset-password", element: <ProfileResetPassword/> },
                    { path:"/me/add-number", element: <AddNumber/> },
                    { path:"/me/terms-of-use", element: <TermsOFUse/> },
                    { path:"/me/halls-bookings", element: <BookedHalls/> },
                    { path:"/me/trips-bookings", element: <BookedTrips/> },
                    { path:"/me/stay-bookings", element: <BookedStays/> },
                    { path:"/me/book-details/:bookId", element: <BookDetails/> },
                    { path:"/me/hall-book-details/:bookId", element: <HallBookDetails/> },
                    { path:"/me/bookTrip-details/:bookId", element: <BookTripDetails/> }
                ]
            },
        ]
    },
    {
  path: "/dashboard",
  element: <ProtectedRoute />,
  children: [
    { index: true, element: <Books/> },
    { path: "trip-bookings", element: <TripBooks /> },
    { path: "stays", element: <StayPage /> },
    { path: "users", element: <Users /> },
    { path: "policy", element: <Policy /> },
    { path: "services", element: <ServicePage /> },
    { path: "articles", element: <ArticlePage /> },
    { path: "hall", element: <HallPage /> },
    { path: "place-details/:placeId", element: <PlaceDetails /> },
    { path: "place-rooms/:placeId", element: <Rooms /> },
    { path: "stay-booking-report/:placeId", element: <PlaceBooking /> },
    { path: "hall-booking-report/:placeId", element: <HallBooking /> },
    { path: "trip-booking-report/:tripId", element: <TripBooking /> },
    { path: "user-booking-report/:userId", element: <UserBooking /> },
    { path: "user-trip-booking-report/:userId", element: <UserTripBooking /> },
    { path: "book-details/:bookId", element: <AdminBookDetails /> },
    { path: "hall-book-details/:bookId", element: <AdminHallBookDetails /> },
    { path: "trip-book-details/:bookId", element: <AdminTripBookDetails /> },
    { path: "place-modal/:placeId?", element: <StayModal /> },
    { path: "settings", element: <SettingPage /> },
    { path: "flights", element: <Flight /> },
    { path: "trips", element: <Trip /> },
    { path: "trip-details/:tripId", element: <TripDetails /> },
    { path: "trip-modal/:tripId?", element: <TripModal /> },
  ]
},
    {
        path: "/auth",
        caseSensitive: false,
        element: <Auth />,
        children: [
            { path: "/auth/login", element: <LoginForm /> },
            { path: "/auth/register", element: <RegisterForm /> },
            { path: "/auth/forget-password", element: <ForgetPassword /> }
        ]
    },
    { path: "*", element: <NotFound /> },
    { path: "/success", element: <Success /> },
]); 
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <HelmetProvider>
        <Provider store={store}>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <RouterProvider router={router} />
                <Toaster />
            </GoogleOAuthProvider>
        </Provider>
        </HelmetProvider>
    </React.StrictMode>
);